/**
 * @module features/client
 * @description Public barrel export for Client Portal components and pages.
 */

export * from "./pages/ClientLoginPage";
